import { QRCodeSVG } from "qrcode.react";

export function TotpQr({ otpauth }: { otpauth: string }) {
  if (!otpauth.trim()) return null;
  return (
    <div className="users-admin-totp-qr">
      <QRCodeSVG value={otpauth} size={176} marginSize={4} level="M" bgColor="#ffffff" fgColor="#0f172a" title="Authenticator App QR" />
    </div>
  );
}
